import { TeamMember, DurationOption, CalendarPlatform } from "../types/meeting.js";

export const TEAM_MEMBERS: TeamMember[] = [
  { name: "Eliza Keffeler", email: "eliza.keffeler@westtn.consulting" },
  { name: "Charlie Keffeler", email: "charlie.keffeler@westtn.consulting" },
  { name: "Jimmy Turner", email: "jimmytreb@gmail.com" },
  { name: "Miclain Keffeler", email: "miclainkeffeler@westtn.consulting" },
];

export const DURATION_OPTIONS: DurationOption[] = [
  { value: 15, label: "15 minutes" },
  { value: 30, label: "30 minutes" },
  { value: 45, label: "45 minutes" },
  { value: 60, label: "1 hour" },
  { value: 90, label: "1.5 hours" },
  { value: 120, label: "2 hours" },
];

export const PLATFORM_OPTIONS = [
  { value: "google", label: "Google Calendar" },
  { value: "microsoft", label: "Microsoft Calendar" },
  { value: "professional-email", label: "WTC Email Calendar" },
] as const satisfies ReadonlyArray<{ value: CalendarPlatform; label: string }>;

const PLATFORM_LABELS: Record<CalendarPlatform, string> = {
  google: "Google Calendar",
  microsoft: "Microsoft Calendar",
  "professional-email": "WTC Email Calendar",
};

const PLATFORM_SHORT_LABELS: Record<CalendarPlatform, string> = {
  google: "Google",
  microsoft: "Microsoft",
  "professional-email": "WTC Email",
};

/** Full label, e.g. "WTC Email Calendar". */
export function getPlatformLabel(platform: CalendarPlatform): string {
  return PLATFORM_LABELS[platform] ?? platform;
}

/** Short label for inline sentences (e.g. "created in WTC Email Calendar"). */
export function getPlatformShortLabel(platform: CalendarPlatform): string {
  return PLATFORM_SHORT_LABELS[platform] ?? platform;
}

export const MODAL_IDS = {
  CREATE_MEETING: "create-meeting",
  MOBILE_CREATE_MEETING: "mobile-create-meeting",
  CONFIRMATION: "meeting-confirmation",
  ATTENDEE_INFO: "meeting-attendee-info",
  SUCCESS: "meeting-success",
} as const;
